module.exports = __webpack_public_path__ + "static/img/spray_3.28bd9a4b.png";